var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _g2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableerror(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 137,
    viewBox: "0 0 140 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.59155,
    cy: 117.771,
    r: 6.59155,
    fill: "#FEE9E9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.801,
    cy: 105.32,
    r: 3.80845,
    fill: "#FEE9E9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.1327,
    cy: 33.8397,
    r: 4.39437,
    fill: "#FEE9E9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 121.871,
    cy: 33.8397,
    r: 4.39437,
    fill: "#FEE9E9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.15,
    cy: 59.4744,
    r: 6.59155,
    fill: "#FEE9E9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.8692,
    cy: 77.0509,
    r: 49.9493,
    fill: "#FCD9D8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2275_4759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2773 34.0273L31.4082 84.145C31.4101 84.8909 31.827 85.5738 32.4896 85.9164L70.0167 105.319V50.1359L31.2773 34.0273Z",
    fill: "url(#paint0_linear_2275_4759)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.756 34.0273L108.625 84.145C108.623 84.8909 108.206 85.5738 107.544 85.9164L70.0165 105.319V50.1359L108.756 34.0273Z",
    fill: "url(#paint1_linear_2275_4759)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.756 34.03L70.5642 23.1559C70.2062 23.054 69.8268 23.054 69.4688 23.1559L31.2771 34.03L70.0165 50.1714L108.756 34.03Z",
    fill: "url(#paint2_linear_2275_4759)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4785 39.9897L58.1517 26.3672L48.9236 29.0038L86.7151 43.2123L94.4785 39.9897Z",
    fill: "#FBC8C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4785 39.9933L94.6616 48.7396L86.8982 51.9621L86.7152 43.216L94.4785 39.9933Z",
    fill: "#FBC8C6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_2275_4759)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 70.0151,
    cy: 105.324,
    r: 14.6479,
    fill: "#F86B69",
    fillOpacity: 0.45
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0417 106.867H72.5817L75.9927 110.285L74.9742 111.303L71.5564 107.892V107.352L71.3718 107.161C70.5925 107.831 69.5809 108.234 68.4803 108.234C66.0263 108.234 64.0371 106.245 64.0371 103.791C64.0371 101.337 66.0263 99.3477 68.4803 99.3477C70.9343 99.3477 72.9235 101.337 72.9235 103.791C72.9235 104.891 72.5202 105.903 71.8503 106.682L72.0417 106.867ZM65.4042 103.791C65.4042 105.493 66.7782 106.867 68.4803 106.867C70.1824 106.867 71.5564 105.493 71.5564 103.791C71.5564 102.089 70.1824 100.715 68.4803 100.715C66.7782 100.715 65.4042 102.089 65.4042 103.791Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2275_4759",
    x: 4.27734,
    y: 0.078125,
    width: 131.479,
    height: 136.242,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.972549 0 0 0 0 0.421111 0 0 0 0 0.411765 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2275_4759"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2275_4759",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_2275_4759",
    x: 47.3672,
    y: 82.6758,
    width: 45.2949,
    height: 45.2969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2275_4759"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2275_4759",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2275_4759",
    x1: 31.2773,
    y1: 86.1975,
    x2: 75.786,
    y2: 60.0714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDBDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2275_4759",
    x1: 108.756,
    y1: 86.1975,
    x2: 57.4731,
    y2: 54.2353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC8C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2275_4759",
    x1: 86.5614,
    y1: 51.113,
    x2: 42.5442,
    y2: 18.3349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD8D8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableerror);
export default __webpack_public_path__ + "static/media/tableerror.162f4fb906b106ef5356ce1775cff30c.svg";
export { ForwardRef as ReactComponent };